import { ActionTree } from 'vuex';
import { setupApollo } from '@/lib/apollo_setup';
import { FETCH_NAVIGATION_BADGES } from '@/graphql/navigation/queries';
import { NavigationState } from './types';

const POLL_INTERVAL_MS = 60000;

const apolloProvider = setupApollo();
let pollingIntervalId: number | null = null;

const actions: ActionTree<NavigationState, any> = {
  async startPolling({ dispatch }) {
    if (pollingIntervalId) return;

    await dispatch('fetchNavigationData');
    pollingIntervalId = window.setInterval(() => {
      dispatch('fetchNavigationData');
    }, POLL_INTERVAL_MS);
  },

  async fetchNavigationData({ commit }) {
    try {
      const result = await apolloProvider.defaultClient.query({
        query: FETCH_NAVIGATION_BADGES,
        fetchPolicy: 'network-only',
      });

      const data = result?.data;
      const receivedAppsCount = data?.viewer?.totalReceivedApplications ?? 0;
      const unreadBookingRequestsCount = data?.viewer?.requests?.totalCount ?? 0;
      const unreadMessageCount = data?.unreadMessageCount ?? 0;

      commit('setReceivedAppsCount', receivedAppsCount);
      commit('setUnreadMessageCount', unreadMessageCount);
      commit('setUnreadBookingRequestsCount', unreadBookingRequestsCount);
    } catch (error) {
      console.error('GraphQL query error fetching navigation badges:', error);
    }
  },

  stopPolling() {
    if (pollingIntervalId) {
      clearInterval(pollingIntervalId);
      pollingIntervalId = null;
    }
  },
};

export default actions;
